// extracted by mini-css-extract-plugin
module.exports = {"cardWrapper":"styles_cardWrapper__3Dpg_","avatar":"styles_avatar__185Rv","name":"styles_name__1nZ_z","position":"styles_position__3KFYf"};